<template>
  <el-row class="mt-2" :gutter="10" v-if="customer != null">
    <el-col
      :lg="12"
      :md="6"
      style="white-space: nowrap; overflow-x: hidden; text-overflow: ellipsis"
      :title="customer.address"
    >
      <div class="bg-White p-3">
        <span>العنوان : </span>
        <span>{{ customer.address }}</span>
      </div>
    </el-col>
    <el-col :lg="4" :md="6">
      <div class="bg-White p-3">
        <span>الهاتف : </span>
        <span>{{ customer.phone }}</span>
      </div>
    </el-col>
    <el-col :lg="4" :md="6">
      <div class="bg-White p-3">
        <span>الحساب : </span>
        <span
          class="num"
          v-if="
            +customer.balance + +customer.account >= 0
          "
          >{{
            numberToFixed(
              +customer.balance + +customer.account
            )
          }}</span
        >
        <span class="num" v-else>{{
          numberToFixed(
            +customer.balance + +customer.account * -1
          )
        }}</span>
        <span
          v-if="
            +customer.balance + +customer.account >= 0
          "
          > مدين </span
        >
        <span v-else> دائن </span>
      </div>
    </el-col>
    <el-col :lg="4" :md="6" v-if="type === 'customer'">
      <div class="bg-White p-3">
        <span>نظام التسعير : </span>
        <span v-if="customer.price_type == 1">جملة الجملة</span>
        <span v-if="customer.price_type == 2">جملة</span>
      </div>
    </el-col>
  </el-row>
</template>
<script>
export default {
  props: ["customer", "type"],
  methods: {
    numberToFixed(number) {
      return Number(number).toFixed(2);
    },
  },
};
</script>
